import React from 'react'
import { SubmitButton } from '@components/ui/Button'
import Translations from '@helpers/translations'
import styles from './styles.module.scss'
import { SubmitButtonHandlers } from '@components/ui/Button/SubmitButton'

type ReturnsBannerProps = {
  type: 'deliveryMethod' | 'returnsRequest'
  copy: string
  onAction: (args: SubmitButtonHandlers) => void
  active: boolean
  buttonActive: boolean
}

function ReturnsBanner({
  type,
  copy,
  onAction,
  active,
  buttonActive
}: ReturnsBannerProps) {
  return (
    <div
      className={`grid ${styles.returnsBanner__content} ${
        active ? styles.active : ''
      }`}
    >
      <div className={styles.returnsBanner__details}>
        <div className={styles.returnsBanner__details__text}>
          {type === 'returnsRequest' && (
            <p className={styles.returnsBanner__title}>
              {Translations.localise('pages.returns.confirm-and-continue')}
            </p>
          )}
          <p
            className={`${styles.returnsBanner__details__byline} ${
              type === 'returnsRequest'
                ? styles.returnsBanner__details__byline_small
                : ''
            }`}
          >
            {copy}
          </p>
        </div>
      </div>
      <div className={styles.returnsBanner__button}>
        <SubmitButton
          variant="white"
          onClick={onAction}
          disabled={!buttonActive}
        >
          {`${
            type === 'returnsRequest'
              ? Translations.localise('pages.returns.continue')
              : Translations.localise('pages.returns.generate-return')
          }`}
        </SubmitButton>
      </div>
    </div>
  )
}

export default ReturnsBanner
